export const ITPT_MAX_INPUTS = 30;
